var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollectionShared = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,11h0c-.6,0-1,.5-1,1l-7.2,3.3c0,0-.2.1-.3.2.5.5.9,1,1.2,1.6l7.1-3.2c.7-.3,1.2-1,1.2-1.8,0-.5-.5-1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,16h0c-.6,0-1,.5-1,1l-5.6,2.6s0,0,0,.1v1.5c0,.1,0,.3,0,.4,0,0,.1,0,.2,0,.1,0,.3,0,.4,0l5.9-2.7c.7-.3,1.2-1,1.2-1.8,0-.5-.5-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,6.2c-.2-.5-.6-.8-1-1L13.2,1.3c-.6-.3-1.3-.3-1.9-.2-.2,0-.4.1-.6.2L2.2,5.2c-1,.4-1.5,1.6-1,2.6.2.4.5.6.9.6s.3,0,.4,0c.5-.2.7-.8.5-1.3l8.6-3.9c.2,0,.3,0,.5,0,.1,0,.2,0,.3,0l8.6,3.9-7.8,3.6c0,.1,0,.3,0,.4,0,.6-.1,1.3-.3,1.9.1,0,.2,0,.4,0l8.6-3.9c1-.4,1.5-1.6,1-2.6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4,22.1c-.5,0-1-.4-1-1v-1.5c0-1.1-.9-2-2-2h-4.4c-1.1,0-2,.9-2,2v1.5c0,.5-.4,1-1,1s-1-.4-1-1v-1.5c0-2.1,1.7-3.9,3.9-3.9h4.4c2.1,0,3.9,1.7,3.9,3.9v1.5c0,.5-.4,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3,14.8c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9,3.9,1.7,3.9,3.9-1.7,3.9-3.9,3.9ZM7.3,9c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollectionShared);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collection-shared.7eb1bf4b7bce6869b830468651bedc98.svg";